export const Doptions = [
    {
        title: "2025 - 2026",
        path: "",
        year: "2025 - 2026"
    },
    {
        title: "2024 - 2025",
        path: "events24-25",
        year: "2024 - 2025"
    },
    {
        title: "2023 - 2024",
        path: "events23-24",
        year: "2023 - 2024"
    }
    , {
        title: "2022 - 2023",
        path: "events22-23",
        year: "2022 - 2023"
    },
    {
        title: "2021 - 2022",
        path: "events21-22",
        year: "2021 - 2022"
    },
    {
        title: "2020 - 2021",
        path: "events20-21",
        year: "2020 - 2021"
    },
    {
        title: "2019 - 2020",
        path: "events19-20",
        year: "2019 - 2020"
    },
    {
        title: "2018 - 2019",
        path: "events18-19",
        year: "2018 - 2019"
    }
]
export const navItems = [
    {
        id: 1,
        title: "Home",
        path: "/"
    },
    {
        id: 2,
        title: "Events",
        path: "/events"
    },
    {
        id: 3,
        title: "Gallery",
        path: "/gallery"
    },
    {
        id: 4,
        title: "Team",
        path: "/team25"
    },
    {
        id: 5,
        title: "Memberships",
        path: "/memberships"
    },
    {
        id: 6,
        title: "ContactUs",
        path: "/#ctus"
    }
]
export const gallHashItems = [
    {
        id: 1,
        title: "2022-2023",
        path: "/gallery#gall2022-23"
    },
    {
        id: 2,
        title: "2021-2022",
        path: "/gallery#gall2021-22"
    },
    {
        id: 3,
        title: "2020-2021",
        path: "/gallery#gall2020-21"
    },
    {
        id: 4,
        title: "2019-2020",
        path: "/gallery#gall2019-20"
    },
    {
        id: 5,
        title: "2018-2019",
        path: "/gallery#gall2018-19"
    },


]
export const eventHashItems = [
    {
        id: 1,
        title: "2024-2025",
        path: "/events#eves2023-24"
    },
    {
        id: 2,
        title: "2023-2024",
        path: "/events#eves2023-24"
    },
    {
        id: 3,
        title: "2022-2023",
        path: "/events#eves2022-23"
    },
    {
        id: 4,
        title: "2021-2022",
        path: "/events#eves2021-22"
    },
    {
        id: 5,
        title: "2020-2021",
        path: "/events#eves2020-21"
    },
    {
        id: 6,
        title: "2019-2020",
        path: "/events#eves2019-20"
    },
    {
        id: 7,
        title: "2018-2019",
        path: "/events#eves2018-19"
    },


]
export const teamItems = [
    {
        id: 1,
        title: "2022-2023",
        path: "/ourTeam"
    },
    {
        id: 2,
        title: "2021-2022",
        path: "/ourTeam2021-22"
    },
    {
        id: 3,
        title: "2020-2021",
        path: "/ourTeam2020-21"
    },
    {
        id: 4,
        title: "2019-2020",
        path: "/ourTeam2019-20"
    },
    {
        id: 5,
        title: "2018-2019",
        path: "/ourTeam2018-19"
    },


]